import {AfterViewInit, Component, ElementRef, QueryList, ViewChildren} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {isNumber} from 'util';
import {WebsiteStatesService} from '../../website-states.service';
import {BreakpointConfig} from '../../website-states.enum';

@Component({
  selector: 'bb-customer-statement',
  templateUrl: './customer-statement.component.html',
  styleUrls: ['./customer-statement.component.scss'],
})
export class CustomerStatementComponent implements AfterViewInit {
  explicitIndex = new ReplaySubject<number>(1);
  interval = Observable.interval(5000).startWith(-1).map(n => n + 1);

  indexDelta = this.explicitIndex.startWith(null)
    .switchMap(explicitIndex => isNumber(explicitIndex) && this.explicitIndex || this.interval)
    .map(n => n % 3)
    .scan((oldDelta, currIndex) => [oldDelta[1], currIndex], [0, 1, 2])
    .shareReplay(1);

  quoteIndex = this.indexDelta.map(([o, n]) => n);
  previousIndex = this.indexDelta.map(([o, n]) => o);

  @ViewChildren('quote') articles: QueryList<ElementRef<HTMLElement>>;

  fontSize = this.website.viewport
    .map((config: BreakpointConfig) => {
      if (config.gteXSmall) {
        return '12px';
      }
      return '18px';
    })
    .shareReplay(1);

  constructor(private $el: ElementRef,
              private website: WebsiteStatesService) {
  }

  ngAfterViewInit() {

    Observable
      .merge(this.articles.changes.startWith(null), this.website.windowResize.throttleTime(200))
      .subscribe(() => {
        const $el: HTMLElement = this.$el.nativeElement;

        // Set height of Container
        const maxHeight: number = this.articles
          .reduce((oldHeight, elRef) => Math.max(oldHeight, elRef.nativeElement.offsetHeight), 0);
        $el.style.setProperty('--quote-height', `${maxHeight}px`);

        // Set Negative margins of Quotes
        this.articles.map((elRef) => elRef.nativeElement.style.marginBottom = `-${elRef.nativeElement.offsetHeight}px`);
      });
  }

  isActive(index: number): Observable<boolean> {
    return this.quoteIndex.map(n => n === index);
  }

  isPrevious(index: number): Observable<boolean> {
    return this.previousIndex.map(n => n === index);
  }
}
